import { getCoreDataSecurityDataAccessSearchHistorySlice } from './get';

export const { requestGetCoreDataSecurityDataAccessSearchHistory, resetGetCoreDataSecurityDataAccessSearchHistory } =
    getCoreDataSecurityDataAccessSearchHistorySlice.asyncActionCreators;
